import _classCallCheck from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/createClass.js";
import { Guid as P, logger as E } from "../../shared-lib/index.js";
import { isArray as D } from "../util/code-utils.js";
import { getErrorMessage as si } from "../util/error-utils.js";
var _t = /*#__PURE__*/function () {
  function _t(t, e, i) {
    _classCallCheck(this, _t);
    this.eu = t, null == t && (t = P.oe()), !i || isNaN(i) ? this.Gl = new Date().valueOf() : this.Gl = i, this.eu = t, this.ql = new Date().valueOf(), this.kl = e;
  }
  _createClass(_t, [{
    key: "dt",
    value: function dt() {
      return "g:".concat(encodeURIComponent(this.eu), "|e:").concat(this.kl, "|c:").concat(this.Gl, "|l:").concat(this.ql);
    }
  }], [{
    key: "AE",
    value: function AE(t) {
      if ("string" != typeof t) return null;
      var e = t.lastIndexOf("|e:"),
        i = t.substring(0, e),
        r = i.split("g:")[1];
      var n;
      return n = /[|:]/.test(r) ? encodeURIComponent(r) : r, t = t.replace(i, "g:".concat(n));
    }
  }, {
    key: "qn",
    value: function qn(t) {
      var e;
      if ("string" == typeof t) try {
        var i = t.split("|");
        if (!D(i) || 4 !== i.length) return null;
        var r = function r(t) {
            return t.split(":")[1];
          },
          n = function n(t) {
            var e = parseInt(r(t));
            if (!isNaN(e)) return e;
          };
        e = new _t(decodeURIComponent(r(i[0])), n(i[1]), n(i[2])), e.ql = n(i[3]);
      } catch (e) {
        E.info("Unable to parse cookie string ".concat(t, ", failed with error: ").concat(si(e)));
      } else {
        if (null == t || null == t.g) return null;
        e = new _t(t.g, t.e, t.c), e.ql = t.l;
      }
      return e;
    }
  }]);
  return _t;
}();
export { _t as default };